import { Pagination } from "antd";
import { useEffect, useState } from "react";
import { getNewTickets } from "../network/network";
import TicketsTable from "./TicketsTable";
import { useTranslation } from "react-i18next";
import { handleApiError } from "../utils/errorHandler";

const NewTickets = () => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paginationData, setPaginationData] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [perPageSize, setPerPageSize] = useState(10);
  const { t } = useTranslation();

  useEffect(() => {
    setLoading(true);
    getNewTickets({
      page: currentPage,
      per_page: perPageSize,
    })
      .then((response) => {
        if (response?.data?.success === false) {
          handleApiError(response, t);
          return;
        }

        setTickets(response.data.data.tickets);
        setPaginationData(response.data.data.pagination);
      })
      .catch((error) => handleApiError(error, t))
      .finally(() => {
        setLoading(false);
      });
  }, [currentPage, perPageSize, t]);

  const handlePagination = (current, pageSize) => {
    setCurrentPage(current);
    setPerPageSize(pageSize);
  };

  return (
    <>
      <TicketsTable
        tickets={tickets}
        loading={loading}
        paginationData={paginationData}
      />

      <Pagination
        current={paginationData.current_page}
        total={paginationData.total}
        pageSize={perPageSize}
        onChange={handlePagination}
        showSizeChanger={true}
        style={{
          marginTop: "20px",
          textAlign: "right",
        }}
      />
    </>
  );
};

export default NewTickets;
